export enum EmployeePayrollTips {
  GET_EMPLOYEE_PAYROLL_TIPS_REQUEST = '@employeePayrollTips/GET_EMPLOYEE_PAYROLL_TIPS_REQUEST',
  GET_EMPLOYEE_PAYROLL_TIPS_SUCCESS = '@employeePayrollTips/GET_EMPLOYEE_PAYROLL_TIPS_SUCCESS',
  GET_EMPLOYEE_PAYROLL_TIPS_FAIL = '@employeePayrollTips/GET_EMPLOYEE_PAYROLL_TIPS_FAIL',

  GET_PAY_PERIOD_PAYROLL_TIPS_REQUEST = '@employeePayrollTips/GET_PAY_PERIOD_PAYROLL_TIPS_REQUEST',
  GET_PAY_PERIOD_PAYROLL_TIPS_SUCCESS = '@employeePayrollTips/GET_PAY_PERIOD_PAYROLL_TIPS_SUCCESS',
  GET_PAY_PERIOD_PAYROLL_TIPS_FAIL = '@employeePayrollTips/GET_PAY_PERIOD_PAYROLL_TIPS_FAIL',
}
